import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Form, Alert } from 'antd';
import EnquiryTitleIcon from 'assets/images/enquiry-title-icon.svg';

import { useEnquirySubmission } from 'all-in-one-shared-api';
import { useKeycloakReady } from 'hooks/useKeycloakReady';
import { FullWidthSpace, PageTitle, PrimaryButton } from 'components';

import { AgreementCard, DocumentsCard, EnquiryInfoCard } from './components';
import { EnquirySuccessPage } from './EnquirySuccessPage';
// import { MessageType } from 'models/MessageType';
import { FormProvider, useForm } from 'react-hook-form';
import { Attachments } from 'types';
// import { uploadFiles } from 'api/uploadEnquiryDocument';
import { revalidateAntdFormLanguageChanged } from '../../../i18n';

type EnquiryFormInput = {
  name: string;
  email: string;
  phone: string;
  enquiryType: string;
  feedback: string;
  attachments: Attachments;
};

export const EnquiryPage = () => {
  const { t, i18n } = useTranslation();
  const [form] = Form.useForm<EnquiryFormInput>();
  const [documentInvalid, setDocumentInvalid] = useState(false);
  const [isAgreed, setIsAgreed] = useState(false);
  const [enquiryReference, setEnquiryReference] = useState('');
  const [attachments, setAttachments] = useState<Attachments>();
  const [isDone, setIsDone] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { token } = useKeycloakReady();
  const methods = useForm();
  const [snackbarMessage, setSnackbarMessage] = useState('');

  useEffect(() => {
    revalidateAntdFormLanguageChanged(form);
  }, [i18n.language, form]);

  const {
    shouldFetch: shouldPostEnquirySubmission,
    data: enquirySubmissionData,
    isLoading: enquirySubmissionIsLoading,
    error,
  } = useEnquirySubmission(
    {
      key: 'useEnquirySubmission',
      params: { form: form.getFieldsValue(), documents: attachments?.fileList.map((a) => a.originFileObj) },
    },
    token || '',
    {
      enquiryType: form.getFieldValue('enquiryType'),
      email: form.getFieldValue('mail'),
      mobile: form.getFieldValue('phone'),
      message: form.getFieldValue('feedback'),
      memberName: form.getFieldValue('name'),
      documents: attachments?.fileList.map((a) => a.originFileObj),
    },
    {
      shouldRetryOnError: false,
      revalidateOnFocus: false,
    },
  );

  useEffect(() => {
    if (enquirySubmissionData) {
      setEnquiryReference(enquirySubmissionData.message);
    }
    if (error) {
      setSnackbarMessage(error.message);
    }
  }, [enquirySubmissionData, error]);

  const handleCloseSnackbar = () => {
    setSnackbarMessage('');
  };
  useEffect(() => {
    if (!snackbarMessage) return;
    shouldPostEnquirySubmission(false);
    setIsLoading(false);
  }, [snackbarMessage, shouldPostEnquirySubmission, isLoading]);

  useEffect(() => {
    if (!enquiryReference) return;
    shouldPostEnquirySubmission(false);
    setIsDone(true);
    setIsLoading(false);

    // if (!attachments?.fileList.length) {
    //   setIsDone(true);
    //   setIsLoading(false);
    //   return;
    // }

    // uploadFiles({
    //   accessToken: token || '',
    //   params: {
    //     //Note Thuy's: please be aware of `fileList` returned by antd
    //     documents: attachments?.fileList.map((a) => a.originFileObj),
    //     referenceNo: enquiryReference,
    //   },
    // })
    //   .then(() => {
    //     setIsDone(true);
    //   })
    //   .catch(() => {
    //     message[MessageType.ERROR](t('common.error.generic'));
    //   })
    //   .finally(() => setIsLoading(false));
  }, [enquiryReference, setIsDone, setIsLoading, shouldPostEnquirySubmission]);

  const onSubmit = (values: EnquiryFormInput) => {
    setSnackbarMessage('');
    setEnquiryReference('');
    setAttachments(values.attachments);
    shouldPostEnquirySubmission(true);
    setIsLoading(true);
  };

  if (isDone) {
    return <EnquirySuccessPage enquiryReference={enquiryReference} />;
  }

  return (
    <FullWidthSpace direction="vertical">
      <PageTitle title={t('enquiry.bannerHeading')} subTitle={t('enquiry.description')} icon={EnquiryTitleIcon} />
      {!!snackbarMessage && (
        <Alert
          message={t('enquiry.error.errormessage')}
          type="error"
          closable
          onClose={handleCloseSnackbar}
          style={{ marginBottom: 16 }}
        />
      )}
      <FormProvider {...methods}>
        <Form requiredMark={false} form={form} layout="vertical" onFinish={onSubmit}>
          <FullWidthSpace direction={'vertical'} size="middle">
            <EnquiryInfoCard />
            <DocumentsCard setInvalid={setDocumentInvalid} />
            <AgreementCard setIsAgreed={setIsAgreed} />
            <PrimaryButton
              loading={enquirySubmissionIsLoading || isLoading}
              disabled={documentInvalid || !isAgreed}
              onClick={() => form.submit()}
            >
              {t('enquiry.submit')}
            </PrimaryButton>
          </FullWidthSpace>
        </Form>
      </FormProvider>
    </FullWidthSpace>
  );
};
